// @spec BCP-STR-027
// Layout route for exercise detail and its child routes (conduct)

import { createFileRoute, Outlet } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/exercises/$exerciseId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.exerciseDetails'),
  }),
  component: ExerciseDetailLayout,
});

function ExerciseDetailLayout() {
  return <Outlet />;
}
